'use client'

import { Checkbox } from '@lastbrand/web-ui/checkbox'
import { css } from '@lastbrand/web-ui-styled-system/css'

import { FormattedPrice } from '@src/blocks/currency'
import { mergeLegacyResponsiveStyles } from '@src/components/blocks/rich-text-ds/classname-to-ds-style'
import { TEST_LOCATORS } from '@src/constants/test-locators'
import type { BundleProductCardPriceAndTitleV2Props } from '@src/quince-site-pdp/src/molecules/bundleProductCard/bundle-product-card-price-and-title-v2.types'

import {
  addOnTitleAndPriceSectionCss,
  addOnTitleClampCss,
  checkboxAndTitleCss,
  checkboxLabelStyle,
  checkboxWrapperStyle,
  pricingCss,
  salePriceBeforeBundleDiscountCss,
  salePriceCss,
  titleAndPriceSectionCss,
  titleAndPriceSectionRawCss,
  titleCss,
  titleRawCss,
} from './bundle-product-card-price-and-title-v2-ds.styles'

const BundleProductCardPriceAndTitleV2DS = ({
  chooseProductText,
  discountedSalePrice,
  salePrice,
  isAddOnProduct = false,
  expanded,
  setExpanded,
}: BundleProductCardPriceAndTitleV2Props) => {
  return (
    <div
      className={
        isAddOnProduct
          ? css(mergeLegacyResponsiveStyles(titleAndPriceSectionRawCss, addOnTitleAndPriceSectionCss))
          : titleAndPriceSectionCss
      }
    >
      <div>
        <div className={isAddOnProduct ? css(mergeLegacyResponsiveStyles(titleRawCss, addOnTitleClampCss)) : titleCss}>
          {chooseProductText}
        </div>
        <div className={pricingCss}>
          <div data-testid={TEST_LOCATORS.BUNDLE_PRODUCT_SALE_PRICE} className={salePriceCss}>
            <FormattedPrice amount={discountedSalePrice} />
          </div>
          <div className={salePriceBeforeBundleDiscountCss}>
            <FormattedPrice amount={salePrice} />
          </div>
        </div>
      </div>
      <div className={checkboxAndTitleCss}>
        {isAddOnProduct ? (
          <Checkbox
            css={checkboxWrapperStyle}
            labelCss={checkboxLabelStyle}
            hasNoLabel
            checked={expanded}
            onCheckedChange={checked => {
              setExpanded(checked === true)
            }}
            aria-label={chooseProductText}
          />
        ) : null}
      </div>
    </div>
  )
}

export default BundleProductCardPriceAndTitleV2DS
